const RanksHeader = () => (
  <div className="ranksHeader">
    <p className="small">RANK</p>
    <p className="small">PLAYER</p>
    <p className="small">SCORE</p>
  </div>
)

export default RanksHeader
